module.exports = __webpack_public_path__ + "img/Number=61.ca62451f.png";